@if (incomeTaxEntity$ |async; as incomeTaxEntity) {
  <snelstart-venture-fiscaal-feature-gewone-giften></snelstart-venture-fiscaal-feature-gewone-giften>

  <snelstart-venture-fiscaal-feature-periodieke-giften></snelstart-venture-fiscaal-feature-periodieke-giften>
}



<form [formGroup]="formGroupSearchAnbi">
    <!--    <div class="mt-2">-->
    <!--        <snelstart-ui-button type="secondary" icon="lightbulb-on"-->
    <!--                (click)="this.showDialog()">Zoek gegevens in het ANBI-register-->
    <!--        </snelstart-ui-button>-->
    <!--    </div>-->

</form>

@if (aangifteRapport$ | async; as aangifteRapport) {
  @if (aangifteRapport.specificatieGiften?.opbouw?.drempelGiften; as drempel) {
    <div class="pt-3 w-50">
      <snelstart-ui-alert type="info">
        De drempel voor aftrek giften bedraagt €
        {{ drempel | number:'1.0-0' }}.
      </snelstart-ui-alert>
    </div>
  }
}


<snelstart-ui-dialog-definition [(visible)]="dialogVisible" id="anbi" size="xl"
                                title="Lijst met ANBI's">
    <snelstart-ui-dialog-header-content>
        Zoek de status en het fiscaalnummer (RSIN) van een (culturere) ANBI in het ANBI-register.
    </snelstart-ui-dialog-header-content>

    <snelstart-ui-dialog-body>
        <div class="row">
            <form [formGroup]="formGroupSearchAnbi">
                <snelstart-ui-alert [showIcon]="false" type="info">
                    <div class="row">
                        <snelstart-ui-text-form-control (change)="searchAnbi()"
                                                        [label]="'Naam ANBI'"
                                                        class="custom-input-250 ps-3"
                                                        formControlName="zoekWaardeNaam"
                                                        id="zoekveld">
                        </snelstart-ui-text-form-control>
                        <snelstart-ui-text-form-control (change)="searchAnbi()"
                                                        [label]="'Vestigingsplaats'"
                                                        class="custom-input-250"
                                                        formControlName="zoekWaardePlaats"
                                                        id="zoekveld2">
                        </snelstart-ui-text-form-control>

                        <snelstart-ui-button (click)="tonenSpinner(); searchAnbi()"
                                             [disabled]="!formGroupSearchAnbi.controls.zoekWaardeNaam.value && !formGroupSearchAnbi.controls.zoekWaardePlaats.value"
                                             class="custom-input-150 pt-3 ps-1"
                                             icon="magnifying-glass"
                                             type="primary">
                            Zoek
                        </snelstart-ui-button>

                        <div *ngIf="showSearchSpinner" class="pt-2">
                            <snelstart-ui-spinner></snelstart-ui-spinner>
                        </div>

                        <div *ngIf="!showSearchSpinner && showResult">
                            <div *ngIf="resultCount < 1" class="mt-2">
                                <div class="d-flex text-left">
                                    <p class="ps-1">Er zijn geen resultaten gevonden. Probeer het
                                        opnieuw.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </snelstart-ui-alert>
            </form>
            <div *ngIf="resultCount > 0">
                <input (input)="filterTable()"
                       [(ngModel)]="searchTerm"
                       class="zoek"
                       placeholder="Zoek in {{resultCount}} resultaten"
                       type="text"
                />
            </div>

            <table class="anbi-table">
                <thead>
                <tr>
                    <th *ngFor="let header of headers">{{ header }}</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let row of filteredRows">
                    <td *ngFor="let cell of row">{{ cell }}</td>
                </tr>
                </tbody>
            </table>

        </div>
    </snelstart-ui-dialog-body>
    <snelstart-ui-dialog-buttons>
        <snelstart-ui-button btn-x class="me-1" id="cancel" type="secondary">Sluiten
        </snelstart-ui-button>
    </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>

